import type { GetCSVResponse } from '@library/types/utils';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';

const { admin } = apiPaths;

export const utilsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCSV: build.query<GetCSVResponse, { ids: Array<string>; path: string }>({
      query: ({ ids, path }) => ({
        url: `${admin}${path}/export`,
        method: 'GET',
        params: {
          'q[id_in]': ids
        },
        headers: {
          Accept: 'multipart/form-data'
        }
      }),
      transformErrorResponse: (response) => response.data
    }),
    getCSVStatus: build.query<GetCSVResponse, string>({
      query: (csvId) => ({
        url: `${admin}export_requests/${csvId}`,
        method: 'GET',
        headers: {
          Accept: 'multipart/form-data'
        }
      }),
      transformErrorResponse: (response) => response.data
    })
  })
});

export const { useLazyGetCSVQuery, useLazyGetCSVStatusQuery } = utilsApi;
